import { composeIO } from 'react-compose-io'
import { formularioPedidoIO } from './FormularioPedido.IO'
import { FormularioPedidoView } from './FormularioPedido.View'

export const FormularioPedido = composeIO(FormularioPedidoView, formularioPedidoIO)
